export default __webpack_public_path__ + "static/media/ORYX_JointCouplingIcon.c0a992c2.svg";